// Mock data for TAF WORLDWIDE cinematography portfolio
// Updated with Bunny.net CDN URLs for faster streaming

export const portfolioItems = [
  // Car Category
  {
    id: 1,
    title: "Urus Mansory",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Urus_Mansory.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Urus%20Mansory%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 2,
    title: "BMW M440 Convertible",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/BMW_M440_Convertible.webm",
    videoUrl: "https://tafworldwide.b-cdn.net/car/BMW%20M440%20Convertible%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 5,
    title: "Porsche GT3",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Porsche_Gt3.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Porsche%20Gt3%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 6,
    title: "Toyota Yaris",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Toyota_Yaris.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Toyota%20Yaris%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 10,
    title: "Lambo Huracan",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Lambo_Huracan.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Lambo%20Huracan%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 11,
    title: "BMW M4",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/BMW_M4.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/BMW%20M4%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },

  // Bike Category
  {
    id: 8,
    title: "MSBK Final Race 2",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/msbk_final_race_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/msbk%20final%20race%202.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 9,
    title: "MSBK Final Race 3",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/msbk_final_race_3.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/msbk%20final%20race%203.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 21,
    title: "Panigale",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Panigale.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Panigale%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },

  // Car Category - continuation
  {
    id: 12,
    title: "Honda Civic 1st Gen",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_Civic_1st_Gen.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20Civic%201st%20Gen%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 17,
    title: "Rolling Sby",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Rolling_sby.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Rolling%20sby%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 22,
    title: "GTR R34",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/GTR_R34.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/GTR%20R34%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 23,
    title: "Clubdepiston",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/mm.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/mm%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 31,
    title: "Honda FL5",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_FL5.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20FL5%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },

  // Event Category
  {
    id: 3,
    title: "Race Day Sport",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Race_Day_Sport.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Race%20Day%20Sport%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 7,
    title: "Liberty Walk",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Liberty_Walk.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/Liberty%20Walk%20.mp4",
    isDirectVideo: true,
    description: "Country: Thailand"
  },
  {
    id: 13,
    title: "RWB - Akira Nakai",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/RWB_-_AKIRA_NAKAI.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/RWB%20-%20AKIRA%20NAKAI%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 14,
    title: "SC Custom",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/SC_CUSTOM.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/SC%20CUSTOM%20%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 15,
    title: "Subaru Track Day",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Subaru_Track_Day.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Subaru%20Track%20Day%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 16,
    title: "KL Showroom",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/KL_SHOOW_ROOM.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/KL%20SHOOW%20ROOM%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 18,
    title: "JPM Car Event",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/JPM_CAR_EVENT.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/JPM%20CAR%20EVENT%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 19,
    title: "Track Day Sepang",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Track_Day_Sepang.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Track%20Day%20Sepang%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 20,
    title: "PCM Amend",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/PCM_Amend.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/PCM%20Amend%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 24,
    title: "Omori",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Omori.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Omori.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 25,
    title: "IAMKL 2025",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/iamkl_2025.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/iamkl%202025%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 26,
    title: "Race Day - Koyak Design",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Race_Day_-_koyak_Design.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Race%20Day%20-%20koyak%20Design%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 27,
    title: "Carro Track Day",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/CARRO_TRACK_DAY.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/CARRO%20TRACK%20DAY%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 28,
    title: "S&H Event Automotive",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/SH_EVENT_AUTOMOTIVE.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/S%26H%20EVENT%20AUTOMOTIVE%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 29,
    title: "Dominan Motorsport",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Dominan_Motorsport_1.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Dominan%20Motorsport%201%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },

  // Personal Category
  {
    id: 30,
    title: "Fuji View",
    category: "Personal",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Fuji_View.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Fuji%20View%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },

  // Additional videos
  {
    id: 32,
    title: "Rimba Raid",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/RIMBA_RAID.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/RIMBA%20RAID%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 33,
    title: "RWB - Akira Nakai 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/RWB_-_AKIRA_NAKAI_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/RWB%20-%20AKIRA%20NAKAI%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 34,
    title: "Bugatti Chiron",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Buggati_Chiron.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Buggati%20Chiron%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 35,
    title: "Honda Civic",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_Civic.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20Civic%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 36,
    title: "Fifty Six Brand",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/FIFTY_SIX_BRAND.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/FIFTY%20SIX%20BRAND%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 37,
    title: "Ducati Track Day",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Ducati_Track_Day.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Ducati%20Track%20Day%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 38,
    title: "Harley Davidson",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/HARLEY_DAVIDSON.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/HARLEY%20DAVIDSON%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 39,
    title: "Supercar Ride",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Supercar_Ride.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Supercar%20Ride%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 40,
    title: "JDM Showroom",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/JDM_SHOWROOM.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/JDM%20SHOWROOM%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 41,
    title: "Elrah Exclusive",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/ELRAH_EXCLUSIVE_1.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/ELRAH%20EXCLUSIVE%201%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 42,
    title: "I Am KL 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/I_am_KL_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/I%20am%20KL%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 43,
    title: "S&H Event 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/SH_EVENT_AUTOMOTIVE_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/S%26H%20EVENT%20AUTOMOTIVE%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 44,
    title: "Honda City Design",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_City_Design.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20City%20Design%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 45,
    title: "Guess The Engine",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Guess_The_Enguine.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Guess%20The%20Enguine%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 46,
    title: "Showroom Day",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Showroom_Day.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Showroom%20Day%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 47,
    title: "Kopi Klasik Kemaman",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Kopi_Klasik_Kemaman.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Kopi%20Klasik%20Kemaman%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 48,
    title: "AI Team | Baju Raya",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/AI_Team__Baju_Raya.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/AI%20TEAM%20%7C%20BAJU%20RAYA%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 49,
    title: "Armor ALL x Red Bull",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Armor_ALL_x_RED_Bull.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Armor%20ALL%20x%20RED%20Bull%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 50,
    title: "Suasana Edaran",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/SuasanaEdaran_1.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/SuasanaEdaran%201%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 51,
    title: "BYD",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/BYD.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/BYD%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 52,
    title: "Aventador KV18",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/aventador_kv18.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/aventador%20kv18%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 53,
    title: "Dominan Motorsport 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Dominan_Motorsport_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Dominan%20Motorsport%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 54,
    title: "Zizan Razak",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Zizan_Razak.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Zizan%20Razak%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 55,
    title: "Rodtang x Elrah",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Rodtang_Elrah.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Rodtang%20%2B%20Elrah%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 56,
    title: "Tawanchai x Elrah",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Tawanchai_Elrah.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Tawanchai%20%2B%20Elrah%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 57,
    title: "Hafiz Syahrin x Elrah",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Hafiz_Syahrin_Elrah.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Hafiz%20Syahrin%20%2B%20Elrah%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 58,
    title: "Aeon Championship",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Aeon_Championship.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Aeon%20Championship%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 60,
    title: "BMW S1000K",
    category: "Bike",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/BMW_S1000K.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/BMW%20S1000K%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 61,
    title: "Malaysia Series Cup",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Malaysia_Series_Cup.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Malaysia%20Series%20Cup%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 62,
    title: "Ferrari 812",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Ferrari_812.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Ferrari%20812%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 63,
    title: "Mega Gathering 2025",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Mega_Gathering_2025.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Mega%20Gathering%202025%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 64,
    title: "Suasana Edaran 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/SuasanaEdaran_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/SuasanaEdaran%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 65,
    title: "Toyota Speed Ramp",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Toyota_Speed_Ramp.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Toyota%20Speed%20Ramp%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 66,
    title: "AMG A45",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/AMG_A45.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/AMG%20A45%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 67,
    title: "CKS x Nu Stix",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/CKS_X_NU_STIX.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/CKS%20X%20NU%20STIX%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 68,
    title: "Japan Vlog",
    category: "Personal",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Japan_Vlog.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Japan%20Vlog%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 69,
    title: "Subaru Track Day 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Subaru_Track_Day_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Subaru%20Track%20Day%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 70,
    title: "Carmeet Type R 2025",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Carmeet_Type_R_2025.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Carmeet%20Type%20R%202025%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 71,
    title: "Supercar Gang",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Supercar_Gang.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Supercar%20Gang%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 72,
    title: "Mazda",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Mazda.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Mazda%20%3A)%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 73,
    title: "Brabus",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Brabus.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Brabus%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 74,
    title: "Ferrari Spider",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Ferrari_Spider.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Ferrari%20Spider%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 75,
    title: "Porsche Club MY",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Porsche_Club_My.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Porsche%20Club%20My%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 76,
    title: "Carmeet Type R 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Carmeet_Type_R_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Carmeet%20Type%20R%202.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 77,
    title: "Zakiem Garage",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Zakiem_Garage.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Zakiem%20Garage%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 79,
    title: "Thailand Road",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Thailand_Road.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Thailand%20Road%20.mp4",
    isDirectVideo: true,
    description: "Country: Thailand"
  },
  {
    id: 80,
    title: "Forty Two Seven - Cafe",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Forty_Two_Seven_-_Cafe.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Forty%20Two%20Seven%20-%20Cafe%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 81,
    title: "Zizan Razak 2",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/ZIZAN_RAZAK_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/ZIZAN%20RAZAK%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 83,
    title: "Mercedes A45S",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/MERCEDES_A45S.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/MERCEDES%20A45S%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 84,
    title: "Boss Batik",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Boss_Batik.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Boss%20Batik%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 85,
    title: "Boss Batik 2",
    category: "Commercial",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Boss_Batik_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Boss%20Batik%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 86,
    title: "Japan Vlog 3",
    category: "Personal",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/JAPAN_VLOG_3.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/JAPAN%20VLOG%203%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 87,
    title: "Japan Vlog 2",
    category: "Personal",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Japan_Vlog_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Japan%20Vlog%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 88,
    title: "KV18 Garage",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/KV18_GARAGE.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/KV18%20GARAGE%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },
  {
    id: 89,
    title: "KV18 Garage 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/KV18_GARAGE_2.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/car/KV18%20GARAGE%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Japan"
  },

  // NEW VIDEOS from Bunny.net CDN (videos not in original mock.js)
  {
    id: 90,
    title: "Mercedes AMG A45S",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/MERCEDES_AMG_A45S.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/MERCEDES%20AMG%20A45S%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 91,
    title: "Old Lamborghini",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/OLD_LAMBOR.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/OLD%20LAMBOR%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 911,
    title: "Toyota GR86",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/toyota_gr86.webp",
    videoUrl: "https://tafworldwide.b-cdn.net/bike/toyota%20gt86%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 92,
    title: "Lamborghini",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Lamborghini.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Lamborghini%20%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 93,
    title: "Lamborghini All",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Lamborghini_all.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Lamborghini%20all%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 94,
    title: "Lamborghini SVJ",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Lamborghini_SVJ.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Lamborghini%20SVJ%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 95,
    title: "MC Laren",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/MC_LAREN.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/MC%20LAREN%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 96,
    title: "Ferrari 812 2",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/FERRARI_812_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/FERRARI%20812%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 97,
    title: "Honda Civic 2",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_Civic_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20Civic%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 98,
    title: "Honda Nation",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/honda_nation.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/honda%20nation%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 99,
    title: "Honda Nation 2",
    category: "Event",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/Honda_Nation_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/Honda%20Nation%202%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  },
  {
    id: 100,
    title: "JDM Showroom 2",
    category: "Car",
    type: "video",
    thumbnail: "https://tafworldwide.b-cdn.net/thumbnails/JDM_SHOWROOM_2.jpg",
    videoUrl: "https://tafworldwide.b-cdn.net/car/JDM%20SHOWROOM%202%20%20.mp4",
    isDirectVideo: true,
    description: "Country: Malaysia"
  }
];

export const categories = [
  "All",
  "Car",
  "Bike",
  "Event",
  "Personal",
  "Commercial"
];

export const services = [
  {
    id: 1,
    title: "Wedding Films",
    description: "Not your typical wedding video. Cinematic storytelling from prep to reception.",
    icon: "heart"
  },
  {
    id: 2,
    title: "Corporate",
    description: "Company profiles, product launches, internal comms. Clean and professional.",
    icon: "briefcase"
  },
  {
    id: 3,
    title: "Music Video",
    description: "Concept to final cut. We match your sound with visuals that hit.",
    icon: "music"
  },
  {
    id: 4,
    title: "Commercials",
    description: "Ads that convert. Social content or TVC, we handle both.",
    icon: "tv"
  },
  {
    id: 5,
    title: "Events",
    description: "Multi-cam setup. Same-day highlights available.",
    icon: "calendar"
  },
  {
    id: 6,
    title: "Product Shots",
    description: "Hero shots, lifestyle content. Make your product look premium.",
    icon: "box"
  },
  {
    id: 7,
    title: "Social Content",
    description: "Reels, TikToks, Stories. Optimized for each platform.",
    icon: "smartphone"
  },
  {
    id: 8,
    title: "Custom Projects",
    description: "Got something different? Let's talk.",
    icon: "sparkles"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Quality Over Quantity",
    description: "We focus on delivering exceptional quality in every frame, every shot, every project. Your story deserves nothing less than perfection."
  },
  {
    id: 2,
    title: "Professional Team",
    description: "Our experienced cinematographers and editors bring years of expertise to capture and create content that truly stands out."
  },
  {
    id: 3,
    title: "Complete Service",
    description: "From pre-production planning to final delivery, we handle everything. We shoot, edit, and produce video content for your media needs."
  },
  {
    id: 4,
    title: "For Everyone",
    description: "Whether you're a business, an artist, or celebrating life's moments - we create stunning visual content for all people and purposes."
  }
];
